// String values must match the backend VendorStatus enum names exactly — the API serializes it with
// StringEnumConverter, so a rename on either side silently turns every row grey.
export enum VendorStatus {
    Unknown = 'Unknown',
    NotApplicable = 'NotApplicable',
    NotRequested = 'NotRequested',
    Pending = 'Pending',
    Completed = 'Completed',
    Errored = 'Errored',
    Rejected = 'Rejected',
}

export interface VendorStatusRow {
    vendor: string;
    status: VendorStatus;
    reason: string | null;
    requestedAt: string | null;
    completedAt: string | null;
}

export interface VendorStatusSubgroup {
    title: string;
    // Two owners can share a display name, so the detail-block link is keyed on this, not the title.
    ownerId?: string | null;
    rows: VendorStatusRow[];
}

export interface VendorStatusGroup {
    title: string;
    groupReason: string | null;
    rows: VendorStatusRow[];
    // Optional because the two repos deploy independently — the portal can briefly run against an API
    // that predates the per-owner split.
    subgroups?: VendorStatusSubgroup[];
}

export interface VendorStatusResponse {
    groups: VendorStatusGroup[];
}
